export const API_ROOT = "/api/web/vdev/";
export const checkStatus = response => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    var error = {
      status_code: response.status,
      status_text: response.statusText,
      data: response.json()
    };
    throw error;
  }
};

export const parseJSON = response => {
  return response.json();
};
